import { useEffect, useState } from 'react';
import { useRootConfig } from './rootConfig';
import { initializeFirebase } from '../firebase/config';

export const useInitializeConfig = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);
  const rootConfig = useRootConfig();

  useEffect(() => {
    const init = async () => {
      try {
        await initializeFirebase();
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(err);
        setLoading(false);
      }
    };

    init();
  }, []);

  return { loading, error, rootConfig };
};
